<template>
  <v-container fluid>
    <create-product-drawer :dialog="drawer" @close="drawer=false" @save="onProductCreated"></create-product-drawer>
    <v-layout class="mb-4">
      <v-flex xs6 md6>
        <h3 class="title font-weight-bold">Products</h3>
      </v-flex>
      <v-flex xs6 md6 class="text-xs-right">
        <el-button @click="drawer=true" type="danger" size="small">Create Product</el-button>
      </v-flex>
    </v-layout>
    <el-table :data="list" style="width: 100%"></el-table>
  </v-container>
</template>
<script>
import Service from "@/services";
import CreateProductDrawer from "@/components/CreateProductDrawer";
export default {
  components: {
    CreateProductDrawer
  },
  data() {
    return {
      list: [],
      drawer: false
    };
  },
  created() {},
  methods: {
    openItem(item) {
      this.$router.push("/view/product/" + item.product_id);
    },
    onProductCreated(data) {
      this.drawer = false;
    }
  }
};
</script>
<style scoped>
</style>